import React from "react"

import { Wrapper, Row, ColWithBg, Content } from "../pageElements"

export const Twitter = () => {
  return (
    <Wrapper>
      <Row height={20}>
        <ColWithBg>
          <Content center>TWITTER</Content>
        </ColWithBg>
      </Row>
    </Wrapper>
  )
}
